<template>
    <div>
    <v-card class="pa-1">
        <v-data-table :headers="headers" :footer-props="{ itemsPerPageOptions:[10, 20, 50, 100]}" :options.sync="options" :loading="tableLoad" loading-text="Loading... Please wait" :items="desserts" :server-items-length="totalRecords" class="elevation-0">
            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-toolbar-title class="font-weight-medium headline primary--text">Export Test History</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer />
                    <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" persistent width="290px">
                        <template v-slot:activator="{ on }">
                            <span v-on="on">
                                <v-combobox v-model="computedDateFormattedMomentjs" :value="date" multiple label="Select Date" append-icon="mdi-calendar" hide-details outlined dense></v-combobox>
                            </span>
                        </template>
                        <v-date-picker v-model="date" color="primary" range>
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
                            <v-btn text color="primary" :disabled="date.length != 2 || date[0] > date[1]" @click="onDate(date)">OK</v-btn>
                        </v-date-picker>
                    </v-dialog>
                </v-toolbar>
            </template>
            <template v-slot:item.name="{ item }">
                <div>{{item.name ? item.name : '--'}}</div>
            </template>
            <template v-slot:item.start="{ item }">
                <div>{{ dateTime(item.start) }}</div>
            </template>
            <template v-slot:item.end="{ item }">
                <div>{{ dateTime(item.end) }}</div>
            </template>
            <template v-slot:item.status="{ item }">
                <v-chip small class="text-capitalize font-weight-bold" :color="getStatusColor(item.status)" :style="item.status == 'active' ? 'background: #689f3821 !important;' : item.status == 'completed' ? 'background: #388fc21a !important;' : 'background: #ec6a3312 !important;'" label outlined>
                    {{item.status}}
                </v-chip>
                <v-btn v-if="item.status == 'progress'" class="ml-1" loading icon x-small></v-btn>
            </template>
            <template v-slot:item.created="{ item }">
                <div>{{ dateTime(item.created) }}</div>
            </template>
            <template v-slot:item.actions="{ item }">
                <div class="d-flex justify-center">
                    <span class="table_actions">
                        <v-btn class="ml-1" color="primary" small outlined :disabled="item.status != 'completed'" :href="item.url" target="_blank">Download</v-btn>
                    </span>
                </div>
            </template>
        </v-data-table>
    </v-card>
</div>
</template>
<script>
import { mapActions, mapMutations } from "vuex"
import moment from 'moment'
export default {
    data: () => ({
        date: [moment(new Date()).subtract(30, 'days').format("YYYY-MM-DD"), moment(new Date()).format("YYYY-MM-DD")],
        modal: false,
        totalRecords: 0,
        tableLoad: false,
        search: '',
        desserts: [],
        choose: false,
        userAccount: [],
        highLightFirstEntry: false, 
        headers: [{
                text: 'File name',
                value: 'name'
            },
            {
                text: 'Start Date',
                value: 'start'
            },
            {
                text: 'End Date',
                value: 'end'
            },
            {
                text: 'Status',
                value: 'status'
            },
            {
                text: 'Created',
                value: 'created'
            },
            {
                text: 'Actions',
                align: 'center',
                value: 'actions',
                sortable: false
            },
        ],
        options: {
            page : 1,
            limit : 100,
            itemsPerPage: 10
        },
        setDate: false
    }),
    methods: {
        ...mapActions(['GetResponse']),
        ...mapMutations(['SnackbarSuccess']),
        async setTableData() {
            let startDate = this.setDate ? this.date[0] : null,
                endDate = this.setDate ? this.date[1] : null;
            this.tableLoad = true
            this.reload = true
            let page = this.options.page,
                limit = this.options.itemsPerPage;
            let query = `?page=${page}&limit=${limit}`;
            if (startDate && endDate) {
                query = `?page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}`
            }
            try {
                let url = `/internal/v2/export-history${query}`
                const data = (await this.GetResponse(url)).data
                if (data.success) {
                    this.desserts = data.records
                    this.tableLoad = false
                    this.totalRecords = data.total
                    this.reload = false
                }
                this.tableLoad = false
                this.reload = false
            } catch (err) {
                this.tableLoad = false
                this.reload = false
            }
        },
        getStatusColor(status) {
            switch (status) {
                case 'pending':
                   return 'orange accent-4'
                case 'progress':
                    return 'light-green darken-2'
                case 'completed':
                    return 'primary'
                case 'failed':
                     return 'red'
                default:
                    return 'primary';
            }
        },
        dateTime(date) {
            return moment(date).format('Do MMMM YYYY');
        },
        async onDate(date) {
            this.setDate = true;
            this.$refs.dialog.save(date)
            await this.setTableData()
        },
    },
    computed: {
        computedDateFormattedMomentjs() {
            return this.date.map(res => {
                return this.date ? moment(res).format('YYYY/MM/DD') : ''
            })
        }
    },
    watch: {
        options: {
            async handler() {
                await this.setTableData()
            },
            deep: true,
        },
    },
    async mounted() {
        await this.setTableData()
    },
}
</script>
